import type { CluePublic } from '@cloudfruit-hunts/shared';

interface ImageClueProps {
  clue: CluePublic;
}

export function ImageClue({ clue }: ImageClueProps) {
  const imageUrl = clue.assetUrls[0];

  return (
    <div className="py-4">
      <p className="text-lg text-text-dark leading-relaxed mb-4">
        {clue.contentText}
      </p>
      {imageUrl && (
        <div>
          <div className="rounded-lg overflow-hidden border border-gray-200">
            <img
              src={imageUrl}
              alt="Clue image"
              className="w-full h-auto"
              loading="lazy"
            />
          </div>
          {clue.type === 'stego' && (
            <a
              href={imageUrl}
              download
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 btn-secondary inline-flex items-center gap-2 text-sm"
            >
              Download Image
            </a>
          )}
        </div>
      )}
    </div>
  );
}
